export const userViewCheck = {
  path: '/api/v1/employee',
  method: 'GET',
};

export const userCreateCheck = {
  path: '/api/v1/employee',
  method: 'POST',
};

export const userGroupViewCheck = {
  path: '/api/v1/group',
  method: 'GET',
};

export const userGroupCreateCheck = {
  path: '/api/v1/group',
  method: 'POST',
};

export const userEditCheck = {
  path: '/api/v1/employee',
  method: 'PUT',
};

export const roleViewCheck = {
  path: '/api/v1/roles',
  method: 'GET',
};

export function searchUsers(search, contentType) {
  return {
    accept: contentType,
    path: `employee${search}`,
  };
}

export function getUser(userId) {
  return { path: `employee/${userId}` };
}

export function deleteUser(userId) {
  return {
    path: `employee/${userId}`,
    method: 'DELETE',
  };
}

export function updateUser(userId, body) {
  return {
    path: `employee/${userId}`,
    method: 'PUT',
    body: JSON.stringify(body),
  };
}

export function createUser(userBody) {
  return {
    path: 'employee',
    method: 'POST',
    body: JSON.stringify(userBody),
  };
}

export function searchUserGroups(search, contentType) {
  return {
    accept: contentType,
    path: `user_group${search}`,
  };
}

export function getUserGroup(userGroupId) {
  return { path: `user_group/${userGroupId}` };
}

export function getNonGroupEmployees(userGroupId) {
  return { path: `user_group/${userGroupId}/non_group_employees` };
}

export function deleteUserGroup(userGroupId) {
  return {
    path: `user_group/${userGroupId}`,
    method: 'DELETE',
  };
}

export function updateUserGroup(userGroupId, body) {
  return {
    path: `user_group/${userGroupId}`,
    method: 'PUT',
    body: JSON.stringify(body),
  };
}

export function createUserGroup(userGroupBody) {
  return {
    path: 'user_group',
    method: 'POST',
    body: JSON.stringify(userGroupBody),
  };
}

export function updateUserGroupEmployee(userGroupEmployeeId, body) {
  return {
    path: `user_group_employee/${userGroupEmployeeId}`,
    method: 'PUT',
    body: JSON.stringify(body),
  };
}

export function addEmployeesToGroup(userGroupBody) {
  return {
    path: 'user_group_employee/add_employees_to_group',
    method: 'POST',
    body: JSON.stringify(userGroupBody),
  };
}

export function addEmployeeToGroups(userGroupBody) {
  return {
    path: 'user_group_employee/add_employee_to_groups',
    method: 'POST',
    body: JSON.stringify(userGroupBody),
  };
}

export function getUserGroupEmployee(userGroupEmployeeId) {
  return { path: `user_group_employee/${userGroupEmployeeId}` };
}

export function deleteUserGroupEmployee(userGroupEmployeeId) {
  return {
    path: `user_group_employee/${userGroupEmployeeId}`,
    method: 'DELETE',
  };
}

export function getEmployeeUserGroups(employeeId) {
  return {
    path: `employee/${employeeId}/user_groups`,
  };
}

export function getEmployeeNonMemberUserGroups(employeeId) {
  return {
    path: `employee/${employeeId}/non_member_user_groups`,
  };
}

export function updatePassword(userId, currentPassword, newPassword) {
  return {
    path: `employee/${userId}/password`,
    method: 'PUT',
    body: JSON.stringify({
      currentPassword,
      newPassword,
    }),
  };
}

export function endUserSessions(userId) {
  return { path: `employee/${userId}/logout` };
}

export function getRoles() {
  return { path: 'roles' };
}

export function getPermissions(roleName) {
  return { path: `roles/${roleName}/permissions` };
}
